var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      ref: "errorModal",
      attrs: {
        "overlay-type": "error",
        "html-classes": ["hide--header", "show--modal"],
        narrow: "",
        "initial-visible": _vm.errorStatus,
      },
      on: { close: _vm.onModalClose },
    },
    [
      _c("div", { staticClass: "overlay-dialog" }, [
        _c("h2", {
          staticClass: "overlay-dialog__title",
          domProps: { innerHTML: _vm._s(_vm.errorTitle || _vm.title) },
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "overlay-dialog__text",
          domProps: { innerHTML: _vm._s(_vm.errorMessage || _vm.message) },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "overlay-dialog__buttons" },
          [
            _c("Button", {
              attrs: { level: "primary", type: "button", text: "OK" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onModalClose.apply(null, arguments)
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }